import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import SEO from "@/components/SEO";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setErr("");
    try { const u = await login(form.email, form.password); nav(u.role === "admin" ? "/admin" : "/panelim"); }
    catch (e) { setErr(e.response?.data?.detail || "Giriş başarısız"); }
    finally { setLoading(false); }
  };

  return (
    <>
      <SEO title="Giriş Yap | Estem Sürücü Kursu" canonical="https://www.estemsurucukursu.com/giris"/>
      <section className="px-4 md:px-8 py-12 md:py-20 max-w-md mx-auto">
        <h1 className="font-heading font-bold text-4xl md:text-5xl tracking-tight">Tekrar hoş geldin</h1>
        <p className="mt-2 text-brand-muted">Kayıt sürecini takip etmek için giriş yap.</p>
        <form onSubmit={submit} className="nb-card p-8 bg-white mt-8" data-testid="login-form">
          {err && <div className="mb-4 p-3 bg-brand-error/10 border-2 border-brand-error rounded-xl text-brand-error text-sm font-bold">{err}</div>}
          <div className="space-y-4">
            <div><label className="nb-label">E-posta</label><input required type="email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} className="nb-input mt-1" data-testid="login-email"/></div>
            <div><label className="nb-label">Şifre</label><input required type="password" value={form.password} onChange={e=>setForm({...form, password:e.target.value})} className="nb-input mt-1" data-testid="login-password"/></div>
            <button disabled={loading} className="nb-btn w-full" data-testid="login-submit">{loading ? "Giriş yapılıyor..." : "Giriş Yap"}</button>
          </div>
          <p className="mt-6 text-sm text-center">Hesabın yok mu? <Link to="/basla" className="font-bold underline">Kaydol</Link></p>
        </form>
      </section>
    </>
  );
}
